import React from 'react';
import Modal from 'react-modal';
import './ModalCommon.css'

const WorkModal = ({ isOpen, onRequestClose, data }) => {
    React.useEffect(() => {
        const body = document.querySelector('body');
        if (isOpen) {
            body.style.overflow = 'hidden';
        } else {
            body.style.overflow = 'auto';
        }
    }, [isOpen]);

    const headerStyle = { width: '190px', flexShrink: '0' };

    const handleMouseOver = (e) => {
        e.stopPropagation();
    };

    const handleMouseOut = (e) => {
        e.stopPropagation();
    };

    const createRow = (title, header) => {
        if(!data[header])
            return <></>

        return <>
            <div className='line grey-line'></div>
            <div className='info-container' >
                <div className='default-text' style={headerStyle}>{title}</div>
                <div className='default-text grey-text'>{data[header]}</div>
            </div></>
    }

    return (
        <Modal
            isOpen={isOpen}
            ariaHideApp={false}
            onRequestClose={onRequestClose}
            shouldCloseOnOverlayClick={true}
            shouldReturnFocusAfterClose={true}
            className='common-modal-content'
            overlayClassName='common-modal-overlay'
            onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}
        >
            <div className='center-div' style={{userSelect: 'none'}}>
                <img src={data['thumbnail-filename']} style={{ width: '100%', padding: '1%', userSelect: 'none' }} alt=''></img>
            </div>
            <div style={{ paddingLeft: '1%' }}>
                <div style={{ height: '50px' }}></div>
                <div className='default-text-bigger-2'>{data['title']}</div>
                <div style={{ height: '20px' }}></div>
                <span className='default-text-bigger grey-text newline-able'>{data['desc']}</span>
                <div style={{ height: '120px' }}></div>


                {createRow("Client",'client')}
                {createRow("Project Duration",'project-duration')}
                {createRow("Release Date",'release-date')}
                {createRow("Genre",'genre')}
                {createRow("Running Time",'running-time')}
                {createRow("Location",'location')}
                
                <div className='line grey-line'></div>
                <div style={{ height: '50px' }}></div>

            </div>
        </Modal>
    );
};

export default WorkModal;
